<template>
  <div class="container container-shadow login-container verify-code-get-container">
      <el-form :model="formVal" :rules="formRules" ref="formVal" class="login-box" @submit.native.prevent>
        <div class="verify-code-get-tips">Please enter your MyZFX ID</div>
        <el-form-item prop="email" class="form-row">
            <el-input v-model="formVal.email" placeholder="Email" @blur="setButton" auto-complete="off"></el-input>
        </el-form-item>
        <div class="form-row form-button">
          <el-button @click="submitForm('formVal')" @blur="setButton" :disabled="isDisabled">Send passcode to my mobile phone</el-button>
        </div> 
      </el-form>
  </div>
</template>

<script>
import { validateEmailNeedExist } from 'utils/validate'
import { loginSendSms } from 'service/login'
export default {
  data() {
    return {
      isDisabled: true,
      formVal: {
        email: ''
      },
      formRules: {
        email: [
          { type: 'email', message: 'Invalid email format.', trigger: 'blur' },
          { validator: validateEmailNeedExist, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    window.vuex_store.commit('set_title', 'Login')
  },
  methods: {
    setButton() {
      // 是否禁用提交按钮
      this.$refs.formVal.validate(valid => {
        console.log('valid', valid)
        if (valid) {
          this.isDisabled = !valid
        } else {
          this.isDisabled = !valid
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log('valid', valid)
        if (valid) {
          loginSendSms({ email: this.formVal.email }).then(data => {
            this.$router.push({
              name: 'verifyCodeLogin',
              params: { email: this.formVal.email, phone: data }
            })
          })
          console.log('submit!')
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.verify-code-get-container {
  height: 364px;
  .verify-code-get-tips {
    font-size: 30px;
    line-height: 30px;
    color: #333333;
    line-height: 1;
    text-align: center;
  }
  .form-row.form-row {
    margin-top: 30px;
  }
}
</style>
